import * as api from '@/api/give-course/discuss'
import * as TYPES from './type';

export default {
  //讨论
  async getSKDiscussList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqSKDiscussList(paramets)
    commit(TYPES.SK_DISCUSS_LIST, {
      result
    })
    cb && cb()
  },
  //讨论详情
  async getSKDiscussDetails({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqSKDiscussDetails(paramets)
    commit(TYPES.SK_DISCUSS_DETAILS, {
      result
    })
    cb && cb()
  },
  //讨论添加
  async postSKDiscussAdd({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqSKDiscussAdd(paramets)
    commit(TYPES.SK_DISCUSS_ADD, {
      result
    })
    cb && cb()
  },
  //讨论结束
  async getSKDiscussOver({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqSKDiscussOver(paramets)
    commit(TYPES.SK_DISCUSS_OVER, {
      result
    })
    cb && cb()
  },
  //讨论结果
  async getSKDiscussRes({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqSKDiscussRes(paramets)
    commit(TYPES.SK_DISCUSS_RES, {
      result
    })
    cb && cb()
  },
  //讨论结果--词云
  async getSKDiscussWord({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqSKDiscussWord(paramets)
    commit(TYPES.SK_DISCUSS_WORD, {
      result
    })
    cb && cb()
  },
  //讨论结果点赞
  async postSKDiscussPraise({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqSKDiscussPraise(paramets)
    commit(TYPES.SK_DISCUSS_PRAISE, {
      result
    })
    cb && cb()
  },
}
